<template>
    <v-row>
        <!-- <v-col cols="12" md="4" class="pt-1 pb-4">
            <v-select :items="monthList" v-model="showMonth" hide-details dense @change="updateMonth"></v-select>
        </v-col>
        <v-col cols="12" md="4" class="pt-1 pb-4">
            <v-select :items="yearList" v-model="showYear" hide-details dense @change="updateYear"></v-select>
        </v-col> -->
        <v-col cols="12" md="4"  class="py-0">
            <span class="subtitle-1 font-weight-bold">{{showMonth}}</span>
            &nbsp;
            <span class="subtitle-1 font-weight-bold">{{showYear}}</span>
        </v-col>
        <v-col cols="12" class="py-0">
            <v-row align="center" justify="space-between" class="px-2">
                <v-btn icon :disabled="canGoBack()" small @click="prevWeek()" class="mt-1">
                    
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="subtitle-2 pb-1 px-1 text-center"
                    style="display: inline-block;
                    width: 11.11%;" v-for="(n, i) in 7" :key="i">
                    <div v-if="isToday(showWeekStartDay + i)" style="font-size: 10px; height: 14px; font-weight: bold;">Today</div>
                    <div v-else style="font-size: 8px; height: 14px;" class="pb-1"></div>
                    <div
                    @click="selectDate(showWeekStartDay + i)"
                    :class="((showWeekStartDay + i) === selectedDay ? 'selected-date':'') + ' all-dates mt-1'"
                    >
                        {{(showWeekStartDay + i) | showDayName}}
                        <br>
                        {{(showWeekStartDay + i) | showDayNumber}}
                    </div>
                </div>
                <v-btn icon :disabled="canGoAhead()" small @click="nextWeek()" class="mt-1">
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import moment from 'moment-timezone';
export default {
    name: "DatePicker",
    filters: {
        showDayName(value) {
            let year = this === undefined ? moment().format('YYYY')+'-01-01 00:00:00' : this.showYear+'-01-01 00:00:00'
            return moment(year).dayOfYear(value).format('ddd')
        },
        showDayNumber(value) {
            let year = this === undefined ? moment().format('YYYY')+'-01-01 00:00:00' : this.showYear+'-01-01 00:00:00'
            return moment(year).dayOfYear(value).format('D')
        }
    },
    watch: {},
    methods: {
        isToday(dayNo) {
            return moment(this.showYear).dayOfYear(dayNo).format('YYYY-MM-DD') === this.today.format('YYYY-MM-DD')
        },
        updateMonth() {
            let monthNumber = moment().month(this.showMonth).format("MM")
            if(this.todayMonthNumber >= monthNumber) {
                this.showWeekStart = moment(this.yearList[0]+'-'+monthNumber+'-01').startOf('week')
            } else {
                this.showWeekStart = moment(this.yearList[1]+'-'+monthNumber+'-01').startOf('week')
            }
            if(this.showWeekStart.format('D') !== '1') {
                this.showWeekStart.add(1, 'week')
            }
            this.updateCalendar()
        },
        updateYear() {
            this.showWeekStart = moment(this.showYear+'-01-01') < this.minWeekStart ? this.minWeekStart : moment(this.showYear+'-01-01').startOf('week')
            if(this.showWeekStart.format('D') !== '1' && this.showWeekStart !== this.minWeekStart) {
                this.showWeekStart.add(1, 'week')
            }
            this.updateCalendar()
        },
        selectDate(value) {
            let date = moment().dayOfYear(value)
            if(date >= this.minWeekStart) {
                if(this.today <= date) {
                    this.selectedDay = value
                    this.returnDate = date.format('YYYY-MM-DD')
                }
            } else {
                this.selectedDay = value
                date = moment(this.yearList[1]).dayOfYear(value)
                this.returnDate = date.format('YYYY-MM-DD')
            }
            this.$emit('input', this.returnDate)
        },
        canGoAhead() {
            let toDate = moment(this.showYear+'-01-01 00:00:00').dayOfYear(this.showWeekStartDay)
            return !(this.maxWeekStart > toDate.add(1, 'w'))
        },
        canGoBack() {
            let toDate = moment(this.showYear+'-01-01 00:00:00').dayOfYear(this.showWeekStartDay)
            return !(this.minWeekStart <= toDate.subtract(1, 'w'))
        },
        nextWeek() {
            this.showWeekStart.add(1, 'w')
            this.updateCalendar()
        },
        prevWeek() {
            this.showWeekStart.subtract(1, 'w')
            this.updateCalendar()
        },
        updateCalendar() {
            this.showWeekStartDay = this.showWeekStart.dayOfYear()
            this.showMonth = this.showWeekStart.format('MMMM')
            this.showYear = this.showWeekStart.format('YYYY')
        }
    },
    data() {
        return {
            todayMonthNumber: moment().format("M"),
            selectedDay: moment().dayOfYear(),
            today: moment().startOf('day'),
            showMonth: moment().format('MMMM'),
            showYear: moment().format('YYYY'),
            showWeekStartDay: moment().startOf('week').dayOfYear(),
            monthList: moment.months(),
            yearList: [moment().format('YYYY'), moment().add(1, 'year').format('YYYY')],
            showWeekStart: moment().startOf('week'),
            minWeekStart: moment().startOf('week'),
            maxWeekStart: moment().add(11, 'months').endOf('month'),
            returnDate: moment().format('YYYY-MM-DD'),
        }
    },
    mounted() {
        this.showMonth = moment().dayOfYear(this.selectedDay).format('MMMM')
        let thisMonthIndex = this.monthList.indexOf(this.showMonth)
        if(thisMonthIndex > 0) {
            let x = this.monthList.splice(0, thisMonthIndex)
            this.monthList = this.monthList.concat(x)
        }
        this.$emit('input', this.returnDate)
    }
}
</script>
<style scoped>
    .selected-date {
        background-color: #4E738A;
        color: white;
    }
    .all-dates {
        cursor: pointer;
        border-radius: 8px;
    }
</style>
